import React from 'react';
import { ButtonBlock, ButtonStyle } from '../../styled';
import useModal from '../../useModal';
import { Widget } from 'models/widgetMultiStageOlympiad';
import MultiStageOlympModal from 'features/mainPage/components/Modals/MultiStageOlympModal/MultiStageOlympModal';

const ImproveResult = ({ id, widget }: { id: number; widget: Widget }) => {
  const eventCopyClick = {
    eventType: `regional_rating_modal_improve_result`,
    eventInfo: `Региональный рейтинг: Клик по кнопке Скопировать в модальном окне I тура`,
  };
  const eventOpenModal = {
    eventType: `reqional_rating_improve_result`,
    eventInfo: `Региональный рейтинг: Клик по кнопке Проинформировать муниципалитеты о I туре`,
  };

  const { showModal, handleImproveClick, handleCloseModal, handleCopyClick} = useModal(
    eventOpenModal,
    eventCopyClick,
  );
  return (
    <div>
      <ButtonBlock>
        <ButtonStyle color={'violet'} onClick={handleImproveClick} style={{ width: '360px' }}>
          Проинформировать муниципалитеты
        </ButtonStyle>
        Отправьте муниципалитетам приглашение на олимпиаду
      </ButtonBlock>
      {showModal && (
        <MultiStageOlympModal
          onCopyClick={handleCopyClick}
          title="Проинформировать муниципалитеты о проведении I тура"
          onClose={handleCloseModal}
          cabmunId={id}
          textMessageCopy={widget.modalMessage}
        />
      )}
    </div>
  );
};
export default ImproveResult;
